import { Injectable, Inject } from '@angular/core';

/**
 * @depricated
 */
@Injectable({
  providedIn: 'root'
})
export class ConstantsService {

  constructor(@Inject('sgConstants') private sgConstantsService: any) { }


  getList(name: string) {
    return this.sgConstantsService.getList(name);
  }
}
